module.exports = __webpack_public_path__ + "img/m-plan-3-4.be10e027.png";